import { render, staticRenderFns } from "./SSelectDefinition.vue?vue&type=template&id=2b1b7b7e&scoped=true"
import script from "./SSelectDefinition.vue?vue&type=script&lang=js"
export * from "./SSelectDefinition.vue?vue&type=script&lang=js"
import style0 from "./SSelectDefinition.vue?vue&type=style&index=0&id=2b1b7b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b7b7e",
  null
  
)

export default component.exports